import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'

const getEnabledCountryChannels = ({ countryId }) => {
  const query = `query ($countryId: ID!) {
    country (id: $countryId) {
      countryDefaultSettings {
        enabledChannelBroadAreas
        enabledChannelPreciseLocations
        enabledChannelLetterbox
        enabledChannelEddm
        enabledChannelAdm
        baPerLocation
      }
      code
    }
  }`
  return callAuthorizedGraphQLEndpoint(query, {
    countryId,
  })
}

export { getEnabledCountryChannels }
